import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DateTime } from "luxon";
import { SchoolModel, SchoolYearType } from "model/SchoolModel";

import { api } from "~utils";

import { SchoolYearsView } from "./SchoolYearsView";
import { getSchoolYear } from "./utils";

type SchoolYearsProps = {
  school: SchoolModel;
};

export function SchoolYears(props: SchoolYearsProps) {
  const {
    school: { id, years, hours },
  } = props;

  /*** Hooks **/
  const queryClient = useQueryClient();

  /*** Constants **/
  const now = DateTime.now();

  const schoolYears = {
    currentYear: getSchoolYear({ now, year: "currentYear", existingYears: years }),
    nextYear: getSchoolYear({ now, year: "nextYear", existingYears: years }),
  };

  /*** State **/
  const [selectedTab, setSelectedTab] = useState<"currentYear" | "nextYear">("currentYear");

  const currentSchoolYear = schoolYears[selectedTab];

  const { mutate: setSchoolYears } = useMutation({
    mutationKey: ["schools", id, "years", currentSchoolYear?.id],
    mutationFn: async (payload?: SchoolYearType) => {
      if (!payload) return;

      const { data } = await api({
        method: currentSchoolYear?.id ? "PUT" : "POST",
        url: `api/admin/schools/${id}/years${currentSchoolYear?.id ? `/${currentSchoolYear.id}` : ""}`,
        data: payload,
      });
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
  });

  /*** Render **/
  return (
    <SchoolYearsView
      hours={hours}
      setSchoolYear={setSchoolYears}
      schoolYears={schoolYears}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
    />
  );
}
